(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-lm-header]').forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const toggle = header.querySelector('[data-lm-menu-toggle]');
      const close = () => { toggle?.setAttribute('aria-expanded', 'false'); toggle?.setAttribute('aria-label', 'Open menu'); header.classList.remove('lm-menu-open'); };
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        header.classList.toggle('lm-menu-open', open);
      });
      header.querySelectorAll('.lm-nav a').forEach(a => a.addEventListener('click', close));
      header.addEventListener('keydown', e => {
        if (e.key === 'Escape') { close(); header.querySelectorAll('details[open]').forEach(d => d.open = false); toggle?.focus(); }
      });
      document.addEventListener('click', e => {
        if (!header.contains(e.target)) { close(); header.querySelectorAll('details[open]').forEach(d => d.open = false); }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', e => initialize(e.target));
})();
